module.exports = __webpack_public_path__ + "assets/img/img-step06-02.c2c15acf.png";